(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid"] && !window.DesignMode) return;
  try {
    
      let images = document.querySelectorAll(".mg-image-border");
      let texts = document.querySelectorAll(".overlay-text");
      console.log(images);
      for(let a = 0; a<images.length; ++a)
      {
        let remove = function () {
          return function () {texts[a].classList.remove("overlay-text-display")};
        }

        let add = function () {
          return function () {texts[a].classList.add("overlay-text-display")};
        }
        
        images[a].addEventListener("mouseover",remove());
        images[a].addEventListener("mouseout",add());
      }

  } catch(e) { console.error(e); }
})();
})();
